import {SessionStorage} from '@chekin/core';
import {Analytics} from '@chekin/shared';

const JOURNEY_ID_KEY = 'analytics_journey_id';

function createJourneyId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `j_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
}

function registerJourneyId(journeyId: string | null) {
  Analytics.addEventProperties({journey_id: journeyId});
}

function startGuestJourneyIfAbsent(): string {
  const existing = SessionStorage.get<string>(JOURNEY_ID_KEY);
  if (existing) {
    registerJourneyId(existing);
    return existing;
  }
  const journeyId = createJourneyId();
  SessionStorage.set(JOURNEY_ID_KEY, journeyId);
  registerJourneyId(journeyId);
  return journeyId;
}

function endGuestJourney(): void {
  SessionStorage.remove(JOURNEY_ID_KEY);
  registerJourneyId(null);
}

export {startGuestJourneyIfAbsent, endGuestJourney};
